import { Loader } from "@dune/ui";
import { useGetReferenceableFiles } from "../../api/queries/constructionSiteSubmission.queries";

interface ReferenceableFilesCountBannerProps {
	constructionSiteId: number;
}

export const ReferenceableFilesCountBanner = ({
	constructionSiteId,
}: ReferenceableFilesCountBannerProps) => {
	const { data, isLoading } = useGetReferenceableFiles(constructionSiteId);

	const referenceableFilesCount = data?.length || 0;

	return (
		<div className="bg-orange-400 text-white h-8 flex items-center justify-center relative rounded">
			{isLoading ? (
				<Loader />
			) : (
				`${referenceableFilesCount} fichiers non référencés`
			)}
		</div>
	);
};
